<template>
  <div class="indoorsDataDetWrap mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="leftMenuBox">
      <MenuList @getClickData="getClickData" />
    </div>
    <div class="contentBox">
      <div class="mapBox">
        <MapView :menuData="menuData"
          @getClickData="getClickData" />
        <el-form :inline="true"
          class="selectBox">
          <el-form-item label="">
            <el-select v-model="parameter"
              clearable
              placeholder="选择参数">
              <el-option v-for="item in parameterList"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
              style="margin-left: 10px"
              @click="subTypeSelect">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="detailsList">
        <div class="identification">
          <img :src="
            require(`@/assets/images/xitong/${clickData.status == '在线'
              ? 'online'
              : clickData.status == '离线'
                ? 'offline'
                : 'alert'
              }.png`)
          " />
        </div>
        <ul>
          <li v-for="(v, i) in list"
            :key="i"
            :class="activeKey == v.key ? 'activeLi' : ''"
            @click="changeKey(v)">
            <p>{{ v.name }}</p>
            <h5 :style="{ color: v.status == '异常' ? '#EC5453' : '#333' }">
              {{ v.value }}
            </h5>
            <span>{{ v.unit }}</span>
          </li>
        </ul>
      </div>
      <div class="chartsBox">
        <OmitLine :id="'lineBox'"
          :chartsData="chartsData" />
      </div>
    </div>
    <div class="rightListBox ashComWrap">
      <div class="comTitle">
        <h4>今日告警记录</h4>
        <div class="more"
          @click="$router.push('/alarmManagement')">更多</div>
      </div>
      <div class="comContentBox">
        <AlarmListCom />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import MenuList from "@/components/zixitong/indoorEnvironment/MenuList";
import MapView from "@/components/zixitong/indoorEnvironment/MapView";
import AlarmListCom from "@/components/zixitong/indoorEnvironment/AlarmListCom";
export default {
  components: {
    MenuList,
    MapView,
    AlarmListCom,
  },
  data() {
    return {
      list: [],
      clickData: {},
      menuData: {
        EMSList: [],
        clickData: {},
      },
      parameter: "",
      parameterList: [],
      activeKey: "",
      activeList: {},
      chartsData: {
        xData: [],
        yData: [],
        unit: "",
      },
      status: "",
    };
  },
  methods: {
    async subTypeSelect() {
      let res = await api.subsystemIndoorListByType({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        status: this.status,
        key: this.parameter,
      });
      console.log(res);
    },
    changeKey(item) {
      this.activeKey = item.key;
      this.activeList = item;
      this.$store.commit("SET_LOADING", true);
      this.getChartsData();
    },
    getClickData(data) {
      console.log(data);
      this.menuData.EMSList = data.mapList;
      this.menuData.clickData = data.activeItem;
      this.clickData = data.activeItem;
      this.status = data.status;
      this.list = [];
      this.chartsData.xData = [];
      this.chartsData.yData = [];
      this.chartsData.unit = "";
      this.parameter = "";
      if (this.clickData) {
        this.getListData();
      } else {
        this.$message.error("未选择设备");
      }
    },
    async getListData() {
      let res = await api.subsystemIndoorValue({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.clickData.deviceId,
      });
      if (res && res.data.code == 200) {
        this.list = res.data.data;
        if (this.list.length > 0) {
          this.activeKey = this.list[0].key;
          this.activeList = this.list[0];
          this.getChartsData();
        }
      }
    },
    async getTypeList() {
      let res = await api.subsystemIndoorType({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        this.parameterList = res.data.data;
      }
    },
    async getChartsData() {
      this.chartsData.xData = [];
      this.chartsData.yData = [];
      this.chartsData.unit = "";
      let res = await api.subsystemIndoorCharts({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.clickData.deviceId,
        name: this.activeList.name,
        key: this.activeKey,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        res.data.data.map((v) => {
          this.chartsData.xData.push(dateFtt("hh:mm", new Date(v.ts)));
          this.chartsData.yData.push(v.data.value);
        });
        this.chartsData.unit = res.data.data[0].data.unit;
      }
    },
  },
  created() {
    this.getTypeList();
  },
};
</script>

<style lang="scss" scoped>
.indoorsDataDetWrap {
  @include setFlexBetween;
  .leftMenuBox {
    width: 22%;
    height: 100%;
    background: #fff;
  }
  .contentBox {
    width: 54%;
    height: 100%;
    @include setFlexColumn;
    justify-content: center;
    .mapBox {
      width: 100%;
      height: 68%;
      position: relative;
      .selectBox {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 500;
      }
    }
    .detailsList {
      width: 100%;
      height: 15%;
      background: #fff;
      @include setFlexBetween;
      .identification {
        width: 10%;
        height: 100%;
        @include setFlexCenter;
        img {
          width: 50%;
        }
      }
      ul {
        width: 90%;
        height: 90%;
        @include setFlexStart;
        li {
          width: 12%;
          height: 100%;
          border-right: 1px solid #e9e9e9;
          @include setFlexColumn;
          justify-content: center;
          align-items: center;
          p {
            color: #666;
          }
          h5 {
            margin: 10px 0;
            font-size: 20px;
          }
          span {
            color: #999;
          }
        }
        li:last-child {
          border: none;
        }
        .activeLi {
          background: #e9e9e9;
          border-radius: 10px;
        }
      }
    }
    .chartsBox {
      width: 100%;
      height: 15%;
      background: #fff;
    }
  }
  .rightListBox {
    width: 22%;
    height: 98%;
    .more {
      color: #28cccb;
      cursor: pointer;
      border-bottom: 1px solid transparent;
    }
    .more:hover {
      border-color: #28cccb;
    }
  }
}
</style>